import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import Moment from 'react-moment'
import { deleteInventory, listInventory } from '../actions/inventoryActions'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

let tablerowcolour = ''

const InventoryUnit = ({ unit }) => {
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const deleteItem = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteInventory(id))
      dispatch(listInventory())
      dispatch({ type: 'INVENTORY_DELETE_RESET' })
    }
  }

  if (unit.qty === 0) {
    tablerowcolour = 'table-danger'
  } else if (unit.qty <= unit.lowinventory) {
    tablerowcolour = 'table-warning'
  } else {
    tablerowcolour = ''
  }

  return (
    <tr className={tablerowcolour}>
      <td>{unit.upc}</td>
      <td>{unit.item}</td>
      <td>{unit.manufacturer}</td>
      <td>{unit.subname}</td>
      <td>{unit.qty}</td>
      <td>{unit.lowinventory}</td>
      <td align='right'>
        {unit.cost.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })}
      </td>
      <td align='right'>
        {unit.price.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })}
      </td>
      <td align='right'>
        <Moment format='M/D/YY, h:mm a'>{new Date(unit.updatedAt)}</Moment>
      </td>
      {userInfo && userInfo.isAdmin && (
        <>
          <td>
            <LinkContainer to={`/inventory/edit/${unit._id}`}>
              <Button variant='primary' size='sm'>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            </LinkContainer>
          </td>
          <td>
            <Button
              variant='danger'
              size='sm'
              onClick={() => deleteItem(unit._id)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </td>
        </>
      )}
    </tr>
  )
}

export default InventoryUnit
